import { render } from "./student-profile.vue?vue&type=template&id=7a206352"
import script from "./student-profile.vue?vue&type=script&lang=js"
export * from "./student-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__